module.exports = __webpack_public_path__ + "static/media/logo.caae49d4.png";